import ActionPanel from '../components/ActionPanel.jsx';
import {
  ClockOutlineIcon,
  DsrActiveIcon,
  PlayCircleIcon,
  QuestionMarkCircleIcon,
} from '../components/icons.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { useFlag } from '../flags/FlagContext.jsx';
import {
  DSR_FAQ_PATH,
  HELP_FAQS_PATH,
  HELP_VIDEOS_PATH,
  PROPERTY_PATH,
  WATCH_HELP_PATH,
} from '../navigation/paths.js';

// The Help section — the web counterpart of the app's HelpMenu (screens/Menu/
// HelpMenu.js), reached from the Property screen's menu drawer. Account-level
// rather than home-scoped, so it lives at a bare /help and its back link goes to
// the Property landing. The sections are the app's, in the app's order, with the
// app's icons (components/icons.jsx), and two left out on purpose rather than
// stubbed:
//   • App Tutorial — an interactive tour laid over the mobile app's own live
//     screens (Tutorial/Property.js), teaching the phone app; it has no web form.
//   • Troubleshooting — the phone's Wi-Fi diagnostics (react-native-wifi-reborn,
//     NetInfo); a browser cannot read the network the way a phone can.
// Watch App and Demand Side Response are pilot-only, as in the app. The app also
// limits Watch App help to Android (the watch app is Wear OS); a browser has no
// platform to check, so on the web the pilot flag is the whole gate.
export default function HelpScreen() {
  const pilot = useFlag('pilot');

  return (
    <main className="app-shell screen help-screen">
      <ScreenHeader
        title="Help"
        sub="Support & FAQs"
        backTo={PROPERTY_PATH}
        backLabel="Property"
      />
      <nav className="action-panel-list" aria-label="Help sections">
        <ActionPanel
          to={HELP_VIDEOS_PATH}
          icon={<PlayCircleIcon />}
          title="Videos"
        />
        {pilot ? (
          <ActionPanel
            to={WATCH_HELP_PATH}
            icon={<ClockOutlineIcon />}
            title="Watch App"
          />
        ) : null}
        {pilot ? (
          <ActionPanel
            to={DSR_FAQ_PATH}
            icon={<DsrActiveIcon />}
            title="Demand Side Response"
          />
        ) : null}
        <ActionPanel
          to={HELP_FAQS_PATH}
          icon={<QuestionMarkCircleIcon />}
          title="FAQs"
        />
      </nav>
    </main>
  );
}
